<!-- eslint-disable vue/no-confusing-v-for-v-if -->
<template xmlns:v-scroll="http://www.w3.org/1999/xhtml">
  <div :style="variables"
       :id="$attrs['id']"
       :class="['roomplan', { 'roomplan--edit': editModeActive }, $attrs['class']]"
       @touchend="$emit('move-touchend', editMode.reservation)"
       @touchcancel="$emit('move-touchend', editMode.reservation)"
       @mouseup="updateReservation()"
       @mouseleave="delayedCancelEdit()"
       @mouseenter="stopCancelEdit()">
    <div class="roomplan__layout roomplan__layout--sticky">
      <div class="roomplan__rooms roomplan__rooms--header">
        <div class="left"></div>
        <div class="left"></div>
        <div class="left"></div>
        <div class="left"></div>
      </div>
      <div v-scroll:debounce="{ fn: onscroll, debounce: 5 }" ref="scrollTop" class="roomplan__horizontal-scroll-top">
        <div ref="scrollTopContent" class="roomplan__horizontal-scroll-top__content">
          <!-- +1 is to adjust for grid 1 based indexing instead of 0 based indexing used by most libraries -->
          <div class="roomplan__header">
            <div v-for="(day, idx) in dates" v-if="day.date() === 1 || idx === 0" :style="`grid-column: span ${Math.min(day.daysInMonth() - day.date() + 1, days - idx)}`" class="month">{{ day | moment('MMMM YYYY') }}</div>
          </div>
          <div class="roomplan__header roomplan__header--dates" style="grid-row: span 2;">
            <div v-tooltip="dayTooltip($moment(day).format('YYYY-MM-DD'))"
                 v-for="day in dates"
                 :key="day | moment('YYYYMMDD')"
                 :class="[
                   {'holiday': holidays.hasOwnProperty(($moment(day).format('YYYY-MM-DD'))) },
                   {'weekend': (day.isoWeekday() >= 6)},
                   {'today': today.isSame(day, 'day')},
                   {'last-day-of-month': day.date() === day.daysInMonth()}
                 ]"
                 :data-date="day | moment('YYYYMMDD')"
                 class="day"><span class="day__name">{{ day | moment('dd') }}</span><br><span class="day__number">{{ day | moment('D') }}</span></div>
          </div>
        </div>
      </div>
    </div>
    <div id="roomplan-layout" :style="calculatedVariable" class="roomplan__layout">
      <div :class="['roomplan__rooms', { 'roomplan__rooms--large': lineHeight >= 3.5 }]">
        <div v-tooltip="tooltip(room)"
             v-for="(room, roomIdx) in roomNumberLines"
             :id="`room-head-${roomIdx}`"
             :class="[room.virtual ? '' : findHotelSettingById('roomTypes', room.roomType.id).colorClass, {'room--has-desc': room.description}, {'room--housekeeping': hasLicense('Housekeeping')}]"
             class="left room">
          <span class="room__label" :class="[{'room__label--linked': !room.virtual && hasLicense('LinkedRooms') && !isEmpty(linkedRooms[room.roomNumber])}]" v-html="room.virtual ? '' : `${room.roomNumber} (${room.roomType.abbreviation})`"></span>
          <span v-if="!room.virtual && hasLicense('Housekeeping')" class="room__cleaning-status">
            <i :class="roomCleaningStatusIcon(room.roomNumber, 'fa-light')" /> <!-- inventoryClass(room.roomNumber, today, 'fa-light') ||  -->
          </span>
          <span v-if="!room.virtual && !isEmpty(room.description)" class="room__desc" v-html="room.description"></span>
          <div v-if="!room.virtual" v-show="selectableRooms.includes(room.roomNumber)" class="room__checkbox">
            <hm-input-checkbox v-model="selectedRooms[room.roomNumber]" :label="$t('roomplan.roomplan.roomNumber')" @input="$emit('roomNumberSelected', room.roomNumber, selectedRooms[room.roomNumber])" />
          </div>
          <div v-if="!room.virtual" :id="`tooltip-${slugify(room.roomNumber)}`" class="tooltip" style="display: none;">
            <span class="text--bold">{{ room.name }}</span>
            <span>{{ room.description }}</span>
            <span>{{ room.roomType.name[$shortLocale] }}</span>
            <span>{{ room.roomType.minOccupancy }} - {{ room.roomType.maxOccupancy }} {{ $t('roomplan.roomplan.roomTooltip.personCapacity') }}</span>
            <span v-if="!room.virtual && hasLicense('LinkedRooms') && !isEmpty(linkedRooms[room.roomNumber])">
              <i class="fa fa-link" />&nbsp;{{ linkedRooms[room.roomNumber].join(" + ") }}
            </span>
            <hr>
            <template v-if="hasLicense('Housekeeping')">
              <span><i :class="roomCleaningStatusIcon(room.roomNumber, 'fa-light')" style="padding-right: 0.8rem;" />{{ $t(`HousekeepingRoomStatus.${roomCleaningStatus(room.roomNumber)}`) }}</span>
              <hr/>
            </template>
            <template v-for="inventory in inventoryForRoom(room.roomNumber)">
              <span class="text--bold">{{ $t(`InventoryCountType.${inventory.type}`) }}</span>
              <span>{{ inventory.startDate | toDate }} - {{ inventory.endDate | toDate }}</span>
              <span>{{ inventory.remark }}</span>
              <hr>
            </template>
          </div>
        </div>
        <template v-if="!hasRole('ROLE_UNIT_OWNER')">
          <div class="left room-type">
            <span>{{ $t('roomplan.roomplan.emptyRow') }}</span>
          </div>
          <div v-for="(roomType, idx) in roomTypes" v-if="showRoomTypePlan && !roomType.deleted" :class="[roomType.colorClass, {'room-type--first': idx == 0}]" class="left room-type">
            <span v-html="roomType.abbreviation"></span>
          </div>
          <div class="left" style="opacity: 0;"></div>
        </template>
      </div>
      <div v-scroll:debounce="{ fn: onscroll, debounce: 100 }" ref="scrollBottom" class="roomplan__horizontal-scroll">
        <div ref="scrollBottomContent" class="roomplan__container" @touchmove="ontouchmove">
          <div class="roomplan__reservations">
            <slot />
          </div>
          <div v-for="(room, idx) in roomNumberLines"
               :id="`room-line-${idx}`"
               :data-room="room.roomNumber"
               :data-row="idx"
               :class="[{'roomplan__room__dates--hover': roomHover === room.roomNumber}]"
               class="roomplan__room__dates"
               @mouseover="onmousemove"
               @touchmove="ontouchmove">
            <div v-for="day in dates"
                 :data-date="day | moment('YYYYMMDD')"
                 :class="[{'weekend': (day.isoWeekday() >= 6)}, {'today': today.isSame(day, 'day')}]"
                 class="day"
                 @mousedown="onMousedownRoomDate(room.roomNumber, day)"
                 @touchstart="onMousedownRoomDate(room.roomNumber, day)">
              <i :class="[inventoryClass(room.roomNumber, day)]" class="day__icon"></i>
              <span class="day__placeholder">{{ day | moment('DD') }}</span>
            </div>
          </div>
          <div v-if="!isNil(roomTypeAvailability) && !isNil(roomTypeAvailability.Total) && Object.keys(roomTypeAvailability.Total).length >= days" class="roomplan__room__dates roomplan__room__dates__room-type roomplan__room__dates__room-type--first">
            <div v-for="day in dates"
                 :data-date="day | moment('YYYYMMDD')"
                 :class="[
                   {'weekend': (day.isoWeekday() >= 6)},
                   {'today': today.isSame(day, 'day')},
                   {'overbooking': roomTypeAvailability !== null && roomTypeAvailability.Total[$options.filters.moment(day, 'YYYYMMDD')] < 0}
                 ]"
                 class="day"><span class="day__value day__value--total">{{ roomTypeAvailability === null ? 0 : roomTypeAvailability.Total[$options.filters.moment(day, 'YYYYMMDD')] }}</span></div>
          </div>
          <div v-for="roomType in roomTypes" v-if="showRoomTypePlan && !roomType.deleted && !isNil(roomTypeAvailability) && !isNil(roomTypeAvailability.ByRoomType) && Object.keys(roomTypeAvailability.ByRoomType).length >= days" class="roomplan__room__dates roomplan__room__dates__room-type">
            <div v-for="day in dates"
                 :data-date="day | moment('YYYYMMDD')"
                 :class="[
                   {'weekend': (day.isoWeekday() >= 6)},
                   {'today': today.isSame(day, 'day')},
                   {'overbooking': roomTypeAvailability !== null && !isNil(roomTypeAvailability.ByRoomType[$options.filters.moment(day, 'YYYYMMDD')]) && roomTypeAvailability.ByRoomType[$options.filters.moment(day, 'YYYYMMDD')].value[roomType.id] < 0}
                 ]"
                 class="day"><span class="day__value">{{ roomTypeAvailability === null || isNil(roomTypeAvailability.ByRoomType[$options.filters.moment(day, 'YYYYMMDD')]) ? 0 : roomTypeAvailability.ByRoomType[$options.filters.moment(day, 'YYYYMMDD')].value[roomType.id] }}</span></div>
          </div>
          <resize-sensor @resize="onresize"></resize-sensor>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { chain, isNil, isEmpty, size, round, min, keyBy, toLower, replace, isFunction } from 'lodash';
import ResizeSensor from 'vue-resize-sensor';
import uuid from 'uuid';
import TimerMixin from '../../../mixins/TimerMixin';

export default {
  name: 'Roomplan',

  components: {
    'resize-sensor': ResizeSensor,
  },
  mixins: [HotelmeisterMixin, TimerMixin],

  props: {
    roomTypeAvailability: {
      required: true,
    },
    canAssignRoomNumber: {
      required: true,
    },
    startDate: {
      required: true,
      type: String,
      default: '',
    },
    days: {
      required: false,
      type: Number,
      default: 26,
    },
    lineHeight: {
      required: false,
      type: Number,
      default: 3,
    },
    firstColumnWidth: {
      required: false,
      type: Number,
      default: 11,
    },
    virtualRoomCount: {
      required: false,
      type: Number,
      default: 0,
    },
    additionalColumnWidth: {
      required: false,
      type: Number,
      default: 2,
    },
    editModeActive: {
      required: false,
      type: Boolean,
      default: true,
    },
    showRoomTypePlan: {
      required: false,
      type: Boolean,
      default: true,
    },
    inventory: {
      required: false,
      type: Array,
      default: () => [],
    },
    selectableRooms: {
      required: false,
      type: Array,
      default: () => [],
    },
    selectedRooms: {
      required: false,
      type: Object,
      default: () => ({}),
    },
    holidays: {
      required: false,
      type: Object,
      default: () => ({}),
    },
    housekeeping: {
      required: false,
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      editMode: {
        timer: null,
        reservation: null,
        moveActive: false,
        extendDepartureActive: false,
        extendArrivalActive: false,
      },
      display: {
        initialColumnWidth: 0,
      },
      roomHover: null,
    };
  },

  computed: {
    rooms: function () {
      return isNil(this.hotelSettings.rooms) ? [] : this.hotelSettings.rooms;
    },
    linkedRooms: function() {
      return Object.fromEntries(this.rooms.filter(it => !isEmpty(it.linkedRoomNumbers)).map(it => [it.roomNumber, it.linkedRoomNumbers]));
    },
    allRoomNumbers: function () {
      return isNil(this.hotelSettings.rooms) ? [] : this.roomNumberLines.flatMap(room => room.roomNumber);
    },
    roomTypes: function () {
      return isNil(this.hotelSettings.roomTypes) ? [] : this.hotelSettings.roomTypes;
    },
    today: function () {
      return this.$moment();
    },
    roomNumberPositions: function () {
      return chain(this.roomNumberLines)
        .map((it, idx) => ({ room: it, index: idx }))
        .keyBy('room.roomNumber')
        .mapValues('index')
        .value();
    },
    roomNumberLines: function () {
      const tmp = this.rooms.flatMap(room => [
        room,
        ...Array(room.emptyLinesAfter).fill(0).map((_, i) => ({ roomNumber: `VR::${room.roomNumber}::${i}`, virtual: true })),
      ]);

      const minVirtualRooms = tmp.length < 10 ? 10 : 3;
      const virtualRooms = Array(Math.max(this.virtualRoomCount + minVirtualRooms, round(size(this.rooms) * 0.2, 0) + 3)).fill(0).map((_, i) => ({ roomNumber: `VR::${i}`, virtual: true }));

      return [
        ...tmp,
        ...virtualRooms,
      ];
    },
    roomTypeMap: function () {
      return keyBy(this.roomTypes, 'id');
    },
    dates: function () {
      const moment = this.$moment;
      const startDate = moment(this.startDate, 'YYYYMMDD');
      const ret = [];

      for (let i = 0; i < this.days; i++) {
        ret.push(startDate.clone().add(i, 'days'));
      }

      return ret;
    },
    variables: function () {
      const el = document.getElementsByTagName('html')[0];
      const style = window.getComputedStyle(el, null).getPropertyValue('font-size');
      const fontSize = parseFloat(style);
      return {
        '--line-height': `${this.lineHeight * fontSize}`,
        '--head-line-height': `${2.5 * fontSize}`,
        '--first-col-width': `${this.firstColumnWidth}rem`,
        '--additional-col-width': `${this.additionalColumnWidth}rem`,
        '--visible-days': this.days,
      };
    },
    calculatedVariable: function () {
      return {
        '--column-width': this.calculatedColumnWidth,
        '--column-correction': `calc((${this.calculatedColumnWidth} - ${this.lineHeight * 10}) / 2)`,
      };
    },
    columnWidth: function () {
      return this.lineHeight + 2 + this.additionalColumnWidth;
    },
    calculatedColumnWidth: function () {
      return (!isNil(this.$el) ? this.$el.querySelector('.roomplan__room__dates .day').getBoundingClientRect().width : min([0, this.display.initialColumnWidth])) + this.windowWidth * 0.000000 + min([0, this.display.initialColumnWidth]) * 0.000000;
    },
    windowWidth: function () {
      return this.$store.getters['layout/windowWidth'];
    },
  },

  watch: {
    days: function () {
      this.setTimeout(this.onresize, 500);
    },
    firstColumnWidth: function () {
      this.setTimeout(this.onresize, 500);
    },
    additionalColumnWidth: function () {
      this.setTimeout(this.onresize, 500);
    },
  },

  created: function () {
    // event handler to get room number of reservation we are right now hovering
    this.$on('hoverroomstart', (arg) => {
      this.roomHover = arg;
    });
    this.$on('hoverroomend', (arg) => {
      this.roomHover = this.roomHover === arg ? null : this.roomHover;
    });

    this.$on('reservation-mouseover', (arg) => {
      // eslint-disable-next-line
      if (!isNil(this.editMode.reservation) && this.editMode.reservation._uid !== arg._uid && this.editMode.moveActive) {
        // we are checking for reservation uid, because we want to ignore hovering of the reservation which is in edit mode
        this.editMode.reservation.temp.roomNumber = arg.roomNumber;
      }
    });
    this.$on(['reservation-mousemove', 'reservation-touchmove'], (component, event) => {
      let triggerResize = false;

      if (!isNil(event) && this.editMode.extendDepartureActive) {
        const clientX = !isNil(event.changedTouches) && event.changedTouches.length === 1 ? event.changedTouches[0].clientX : event.clientX;
        const resPosition = component.$el.getBoundingClientRect();
        const left = resPosition.x + resPosition.width - (this.additionalColumnWidth * 10);
        triggerResize = left > clientX;
      }

      if (!isNil(event) && this.editMode.extendArrivalActive) {
        const clientX = !isNil(event.changedTouches) && event.changedTouches.length === 1 ? event.changedTouches[0].clientX : event.clientX;
        const resPosition = component.$el.getBoundingClientRect();
        const left = resPosition.x + (this.additionalColumnWidth * 10);
        triggerResize = left < clientX;
      }

      // eslint-disable-next-line
      if (!isNil(this.editMode.reservation) && this.editMode.reservation._uid === component._uid && this.editMode.extendDepartureActive && triggerResize) {
        // we are checking for reservation uid, because we want to only shorten the reservation of you are hovering the same reservation
        const moment = this.$moment;
        // make sure the stay always is at least 1 day long
        const minCheckOutDate = moment(this.editMode.reservation.reservation.checkInDate, 'YYYYMMDD').add(1, 'day').format('YYYYMMDD');
        if (minCheckOutDate !== this.editMode.reservation.temp.checkOutDate) {
          this.editMode.reservation.temp.checkOutDate = moment(this.editMode.reservation.temp.checkOutDate, 'YYYYMMDD').subtract(1, 'day').format('YYYYMMDD');
        }
      }
      // eslint-disable-next-line
      if (!isNil(this.editMode.reservation) && this.editMode.reservation._uid === component._uid && this.editMode.extendArrivalActive && triggerResize) {
        // we are checking for reservation uid, because we want to only shorten the reservation of you are hovering the same reservation
        const moment = this.$moment;
        this.editMode.reservation.temp.checkInDate = moment(this.editMode.reservation.temp.checkInDate, 'YYYYMMDD').add(1, 'day').format('YYYYMMDD');
      }
    });
    this.$on(['move-touchstart', 'move-mousedown'], (arg) => {
      if (this.editModeActive && arg.canMove) {
        this.cancelEdit();
        arg.temp = {
          roomNumber: arg.reservation.roomNumber,
        };
        this.editMode.reservation = arg;
        this.editMode.moveActive = true;
        this.$emit('editStarted', arg.reservation.reservationId);

        this.addUIBreadcrumb(
          'Roomplan: started dragging of reservation',
          {
            reservationId: arg.reservation.reservationId,
          },
        );
      }
    });
    this.$on(['move-mouseup', 'move-touchend'], (arg) => {
      // eslint-disable-next-line
      if (!isNil(arg) && !isNil(this.editMode.reservation) && arg._uid === this.editMode.reservation._uid) {
        this.updateReservation();
      }
    });
    this.$on(['resize-right-touchstart', 'resize-right-mousedown'], (arg) => {
      if (this.editModeActive && arg.canResizeRight) {
        this.cancelEdit();
        arg.temp = {
          checkOutDate: arg.reservation.checkOutDate,
        };
        this.editMode.reservation = arg;
        this.editMode.extendDepartureActive = true;
        this.$emit('editStarted', arg.reservation.reservationId);

        this.addUIBreadcrumb(
          'Roomplan: started extension of reservation',
          {
            reservationId: arg.reservation.reservationId,
          },
        );
      }
    });
    this.$on(['resize-right-mouseup', 'resize-right-touchend'], (arg) => {
      // eslint-disable-next-line
      if (!isNil(arg) && !isNil(this.editMode.reservation) && arg._uid === this.editMode.reservation._uid) {
        this.updateReservation();
      }
    });
    this.$on(['resize-left-touchstart', 'resize-left-mousedown'], (arg) => {
      if (this.editModeActive && arg.canResizeLeft) {
        this.cancelEdit();
        arg.temp = {
          checkInDate: arg.reservation.checkInDate,
        };
        this.editMode.reservation = arg;
        this.editMode.extendArrivalActive = true;
        this.$emit('editStarted', arg.reservation.reservationId);

        this.addUIBreadcrumb(
          'Roomplan: started bringing forward of reservation',
          {
            reservationId: arg.reservation.reservationId,
          },
        );
      }
    });
    this.$on(['resize-left-mouseup', 'resize-left-touchend'], (arg) => {
      // eslint-disable-next-line
      if (!isNil(arg) && !isNil(this.editMode.reservation) && arg._uid === this.editMode.reservation._uid) {
        this.updateReservation();
      }
    });
  },

  mounted: function () {
    this.display.initialColumnWidth = this.$el.querySelector('.roomplan__room__dates .day').getBoundingClientRect().width;
    this.$refs.scrollTopContent.style.width = `${this.$refs.scrollBottomContent.clientWidth}px`;
  },

  updated: function () {
    this.display.initialColumnWidth = this.$el.querySelector('.roomplan__room__dates .day').getBoundingClientRect().width;
  },

  methods: {
    isEmpty,
    tooltip: function (room) {
      if (isNil(this.$el) || room.virtual) return {};
      return {
        title: () => (isNil(this.$el) || isNil(document.getElementById(`tooltip-${this.slugify(room.roomNumber)}`)) ? '' : document.getElementById(`tooltip-${this.slugify(room.roomNumber)}`).innerHTML),
        closeOnClickOutside: true,
        delay: 500,
        theme: 'light',
        placement: 'top',
        trigger: 'hover focus',
        html: true,
        boundariesElement: 'scrollParent',
        preventOverflow: true,
        positionFixed: false,
        container: 'parent',
      };
    },
    slugify: function (roomNumber) {
      return replace(toLower(roomNumber), /[^a-zA-Z0-9]+/g, '-');
    },
    inventoryClass: function (roomNumber, date, style = 'far') {
      if (isEmpty(this.inventory)) return '';

      date = date.format('YYYYMMDD');
      const inventory = this.inventory.find(it => it.roomNumber === roomNumber && date >= it.startDate && date <= it.endDate);

      if (isNil(inventory)) return '';

      if (inventory.type === 'OutOfOrder') return `${style} fa-ban`;
      if (inventory.type === 'OutOfService') return `${style} fa-hammer`;
      if (inventory.type === 'UnderConstruction') return `${style} fa-digging`;
      if (inventory.type === 'UnderRenovation') return `${style} fa-digging`;
      if (inventory.type === 'OffMarket') return `${style} fa-ban`;
      if (inventory.type === 'ContractSold') return `${style} fa-euro-sign`;
      if (inventory.type === 'LinkedBlocked') return `${style} fa-link`;

      return '';
    },
    inventoryForRoom: function (roomNumber) {
      return this.inventory.filter(it => it.roomNumber === roomNumber);
    },
    inventoryForRoomToday: function (roomNumber) {
      const today = this.today.format('YYYYMMDD');
      return this.inventory.filter(it => it.roomNumber === roomNumber && it.startDate >= today && it.endDate <= today);
    },
    onMousedownRoomDate: function (roomNumber, date) {
      if (this.editModeActive && isEmpty(this.selectableRooms)) {
        if (roomNumber.indexOf('::') >= 0) return;

        date = this.$moment(date);

        const res = {
          reservationId: uuid.v4(),
          checkInDate: date.format('YYYYMMDD'),
          checkOutDate: date.add(1, 'days').format('YYYYMMDD'),
          roomNumber: roomNumber,
          roomTypeId: this.findHotelSettingById('rooms', roomNumber, 'roomNumber').roomType.id,
          numAdults: this.findHotelSettingById('rooms', roomNumber, 'roomNumber').roomType.expectedOccupancy,
          colorCategoryCssClass: '',
        };

        this.$emit('addDraftReservation', res);

        this.addUIBreadcrumb(
          'Roomplan: added draft reservation',
          {
            ...res,
          },
        );
      }
    },
    onscroll: function (event) {
      if (this.$refs.scrollTop.scrollLeft === this.$refs.scrollBottom.scrollLeft) {
        return;
      }

      if (event.target.className === this.$refs.scrollBottom.className) {
        this.$refs.scrollTop.scrollLeft = this.$refs.scrollBottom.scrollLeft;
      } else if (event.target.className === this.$refs.scrollTop.className) {
        this.$refs.scrollBottom.scrollLeft = this.$refs.scrollTop.scrollLeft;
      }
    },
    onresize: function (resize) {
      if (!isNil(this.$refs.scrollTopContent) && !isNil(resize)) {
        this.$refs.scrollTopContent.style.width = `${resize.width}px`;
      } else if (!isNil(this.$refs.scrollTopContent) && !isNil(this.$refs.scrollBottom) && isNil(resize)) {
        this.$refs.scrollTopContent.style.width = this.$refs.scrollBottom.clientWidth;
      }
    },
    updateReservation: function (event) {
      if (!isNil(this.editMode.reservation) && this.editMode.reservation.draft) {
        if (this.editMode.extendDepartureActive) {
          this.editMode.reservation.reservation.checkOutDate = this.editMode.reservation.temp.checkOutDate;
        }
        if (this.editMode.extendArrivalActive) {
          this.editMode.reservation.reservation.checkInDate = this.editMode.reservation.temp.checkInDate;
        }
        if (this.editMode.moveActive) {
          this.editMode.reservation.reservation.roomNumber = this.editMode.reservation.temp.roomNumber;
          // this.editMode.reservation.reservation.numAdults = this.findHotelSettingById('rooms', this.editMode.reservation.reservation.roomNumber, 'roomNumber').roomType.expectedOccupancy;
        }
        this.cancelEdit();
        return;
      }
      if (!isNil(this.editMode.reservation) && this.editMode.moveActive) {
        const reservation = this.editMode.reservation;
        const newRoomNumber = this.editMode.reservation.temp.roomNumber;
        this.editMode.moveActive = false;
        if (newRoomNumber !== reservation.roomNumber) {
          if (!this.canAssignRoomNumber(reservation.reservation, newRoomNumber)) {
            this.showErrorMessage(this.$t('roomplan.roomplan.errorRoomNumberAlreadyInUse'));
            this.cancelEdit();
            return;
          } else if ((newRoomNumber === null || newRoomNumber.startsWith('VR::')) && (reservation.roomNumber === null || reservation.roomNumber.startsWith('VR::'))) {
            reservation.reservation.roomNumber = newRoomNumber;
            this.cancelEdit();
            return;
          } else {
            this.editMode.reservation.updateInProgress = true;
            this.$store.commit('save/started', this.editMode.reservation.reservation.reservationId);
            this.axios.patch(this.serviceUrls.reservation.get(this, this.editMode.reservation.reservation.reservationId), {
              roomNumber: newRoomNumber != null && newRoomNumber.startsWith('VR::') ? null : newRoomNumber,
            })
              .then((response) => {
                this.$store.commit('save/finished', reservation.reservation.reservationId);
                reservation.reservation.roomNumber = newRoomNumber;

                this.showMessages(response);
                this.showSuccessMessage();
                reservation.update().then(() => {
                  this.$nextTick(() => {
                    this.cancelEdit();
                    reservation.$emit('input', reservation.reservation);
                    this.$emit('update');
                    this.addUIBreadcrumb(
                      'Roomplan: Finished editing reservation',
                      {
                        reservationId: reservation.reservation.reservationId,
                      },
                    );
                    reservation.updateInProgress = false;
                  });
                });
              })
              .catch((error) => {
                this.$store.commit('save/finished', reservation.reservation.reservationId);
                this.showMessages(error.response);
                reservation.update().then(() => {
                  this.cancelEdit();
                  reservation.updateInProgress = false;
                });
              });
          }
        }
      }
      if (!isNil(this.editMode.reservation) && this.editMode.extendDepartureActive) {
        const reservation = this.editMode.reservation;
        const newCheckOutDate = this.editMode.reservation.temp.checkOutDate;
        this.editMode.extendDepartureActive = false;
        if (reservation.checkOutDate !== newCheckOutDate) {
          this.editMode.reservation.updateInProgress = true;
          this.$store.commit('save/started', this.editMode.reservation.reservation.reservationId);
          this.axios.patch(this.serviceUrls.reservation.get(this, this.editMode.reservation.reservation.reservationId), {
            checkOutDate: newCheckOutDate,
          })
            .then((response) => {
              this.$store.commit('save/finished', reservation.reservation.reservationId);
              reservation.reservation.checkOutDate = newCheckOutDate;

              this.showMessages(response);
              this.showSuccessMessage();
              reservation.update().then(() => {
                this.cancelEdit();
                reservation.$emit('input', reservation.reservation);
                this.$emit('update');
                this.addUIBreadcrumb(
                  'Roomplan: Finished editing reservation',
                  {
                    reservationId: reservation.reservation.reservationId,
                  },
                );
                reservation.updateInProgress = false;
              });
            })
            .catch((error) => {
              this.$store.commit('save/finished', reservation.reservation.reservationId);
              this.showMessages(error.response);
              reservation.update().then(() => {
                this.cancelEdit();
                reservation.updateInProgress = false;
              });
            });
        }
      }
      if (!isNil(this.editMode.reservation) && this.editMode.extendArrivalActive) {
        const reservation = this.editMode.reservation;
        const newCheckInDate = this.editMode.reservation.temp.checkInDate;
        this.editMode.extendArrivalActive = false;
        if (reservation.checkInDate !== newCheckInDate) {
          this.editMode.reservation.updateInProgress = true;
          this.$store.commit('save/started', this.editMode.reservation.reservation.reservationId);
          this.axios.patch(this.serviceUrls.reservation.get(this, this.editMode.reservation.reservation.reservationId), {
            checkInDate: newCheckInDate,
          })
            .then((response) => {
              this.$store.commit('save/finished', reservation.reservation.reservationId);
              reservation.reservation.checkInDate = newCheckInDate;

              this.showMessages(response);
              this.showSuccessMessage();
              reservation.update().then(() => {
                this.cancelEdit();
                reservation.$emit('input', reservation.reservation);
                this.$emit('update');
                this.addUIBreadcrumb(
                  'Roomplan: Finished editing reservation',
                  {
                    reservationId: reservation.reservation.reservationId,
                  },
                );
                reservation.updateInProgress = false;
              });
            })
            .catch((error) => {
              this.$store.commit('save/finished', reservation.reservation.reservationId);
              this.showMessages(error.response);
              reservation.update().then(() => {
                this.cancelEdit();
                reservation.updateInProgress = false;
              });
            });
        }
      }
    },
    ontouchmove: function (event) {
      if (this.editModeActive) {
        event.preventDefault();
      }

      if (!isNil(this.editMode.reservation) && this.editMode.moveActive) {
        let closest = null;

        if (!isNil(event.changedTouches) && event.changedTouches.length === 1) {
          closest = document.elementFromPoint(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
          closest = closest.closest('.roomplan__room__dates');
        }

        if (!isNil(closest) && !isNil(closest.getAttribute('data-room'))) {
          this.editMode.reservation.temp.roomNumber = closest.getAttribute('data-room');
        }
      }

      if (!isNil(this.editMode.reservation) && this.editMode.extendDepartureActive) {
        let closest = null;

        if (!isNil(event.changedTouches) && event.changedTouches.length === 1) {
          closest = document.elementFromPoint(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
          closest = closest.closest('.day');
        }

        if (!isNil(closest) && !isNil(closest.getAttribute('data-date'))) {
          this.editMode.reservation.temp.checkOutDate = closest.getAttribute('data-date');
        } else {
          let reservationElement = null;
          if (!isNil(event.changedTouches) && event.changedTouches.length === 1) {
            closest = document.elementFromPoint(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
            reservationElement = closest.closest('.room-reservation');
            closest = closest.closest('.room-reservation .label__wrapper');
          }

          if (reservationElement === this.editMode.reservation.$el && !isNil(closest)) {
            const moment = this.$moment;
            // make sure the stay always is at least 1 day long
            const minCheckOutDate = moment(this.editMode.reservation.reservation.checkInDate, 'YYYYMMDD').add(1, 'day').format('YYYYMMDD');
            if (minCheckOutDate !== this.editMode.reservation.temp.checkOutDate) {
              this.editMode.reservation.temp.checkOutDate = moment(this.editMode.reservation.temp.checkOutDate, 'YYYYMMDD').subtract(1, 'day').format('YYYYMMDD');
            }
          }
        }

        if (!this.$moment(this.editMode.reservation.reservation.checkInDate, 'YYYYMMDD').isBefore(this.$moment(this.editMode.reservation.temp.checkOutDate, 'YYYYMMDD'))) {
          this.editMode.reservation.temp.checkOutDate = this.$moment(this.editMode.reservation.reservation.checkInDate, 'YYYYMMDD').add(1, 'day').format('YYYYMMDD');
        }
      }

      if (!isNil(this.editMode.reservation) && this.editMode.extendArrivalActive) {
        let closest = null;

        if (!isNil(event.changedTouches) && event.changedTouches.length === 1) {
          closest = document.elementFromPoint(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
          closest = closest.closest('.day');
        }

        if (!isNil(closest) && !isNil(closest.getAttribute('data-date'))) {
          this.editMode.reservation.temp.checkInDate = closest.getAttribute('data-date');
        } else {
          let reservationElement = null;
          if (!isNil(event.changedTouches) && event.changedTouches.length === 1) {
            closest = document.elementFromPoint(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
            reservationElement = closest.closest('.room-reservation');
            closest = closest.closest('.room-reservation .label__wrapper');
          }

          if (reservationElement === this.editMode.reservation.$el && !isNil(closest)) {
            const moment = this.$moment;
            this.editMode.reservation.temp.checkInDate = moment(this.editMode.reservation.temp.checkInDate, 'YYYYMMDD').add(1, 'day').format('YYYYMMDD');
          }
        }

        if (!this.$moment(this.editMode.reservation.temp.checkInDate, 'YYYYMMDD').isBefore(this.$moment(this.editMode.reservation.reservation.checkOutDate, 'YYYYMMDD'))) {
          this.editMode.reservation.temp.checkInDate = this.$moment(this.editMode.reservation.reservation.checkOutDate, 'YYYYMMDD').add(-1, 'day').format('YYYYMMDD');
        }
      }
    },
    onmousemove: function (event) {
      if (!isNil(this.editMode.reservation) && this.editMode.moveActive) {
        const closest = event.target.closest('.roomplan__room__dates');
        if (!isNil(closest)) {
          this.editMode.reservation.temp.roomNumber = closest.getAttribute('data-room');
        }
      }

      if (!isNil(this.editMode.reservation) && this.editMode.extendDepartureActive) {
        const closest = event.target.closest('.day');
        if (!isNil(closest)) {
          this.editMode.reservation.temp.checkOutDate = closest.getAttribute('data-date');

          if (!this.$moment(this.editMode.reservation.reservation.checkInDate, 'YYYYMMDD').isBefore(this.$moment(this.editMode.reservation.temp.checkOutDate, 'YYYYMMDD'))) {
            this.editMode.reservation.temp.checkOutDate = this.$moment(this.editMode.reservation.reservation.checkInDate, 'YYYYMMDD').add(1, 'day').format('YYYYMMDD');
          }
        }
      }

      if (!isNil(this.editMode.reservation) && this.editMode.extendArrivalActive) {
        const closest = event.target.closest('.day');
        if (!isNil(closest)) {
          this.editMode.reservation.temp.checkInDate = closest.getAttribute('data-date');

          if (!this.$moment(this.editMode.reservation.temp.checkInDate, 'YYYYMMDD').isBefore(this.$moment(this.editMode.reservation.reservation.checkOutDate, 'YYYYMMDD'))) {
            this.editMode.reservation.temp.checkInDate = this.$moment(this.editMode.reservation.reservation.checkOutDate, 'YYYYMMDD').add(-1, 'day').format('YYYYMMDD');
          }
        }
      }
    },
    cancelEdit: function () {
      const tmpReservation = this.editMode.reservation;

      if (!isNil(tmpReservation)) {
        this.$emit('editFinished', tmpReservation.reservation.reservationId);

        this.addUIBreadcrumb(
          'Roomplan: Cancelled editing reservation',
          {
            reservationId: tmpReservation.reservation.reservationId,
          },
        );

        tmpReservation.temp = null;
        this.editMode.reservation = null;
        this.editMode.moveActive = false;
        this.editMode.extendDepartureActive = false;
        this.editMode.extendArrivalActive = false;
      }
    },
    delayedCancelEdit: function () {
      const self = this;
      if (!isNil(this.editMode.timer)) {
        this.clearTimeout(this.editMode.timer);
      }
      this.editMode.timer = this.setTimeout(() => {
        self.cancelEdit();
      }, 500);
    },
    stopCancelEdit: function () {
      if (!isNil(this.editMode.timer)) {
        this.clearTimeout(this.editMode.timer);
      }
    },
    dayTooltip: function (day) {
      if (isNil(this.$el)) return {};
      if (isNil(this.holidays[day])) return null;
      return {
        title: this.holidays[day]
          .map(holiday => `<b>${holiday.originalName}</b><br/>Land: ${this.$root.i18n.countries.getNames(this.$shortLocale)[holiday.country]}<br/>${isEmpty(holiday.regions) ? 'Landesweit' : `Regionen: ${holiday.regions.join(', ')}`}`)
          .join('<br/><br/>'),
        closeOnClickOutside: true,
        delay: 500,
        theme: 'light',
        placement: 'bottom',
        trigger: 'hover focus',
        html: true,
        boundariesElement: 'body',
        preventOverflow: true,
        positionFixed: false,
        container: 'parent',
      };
    },
    roomCleaningStatus(roomNumber) {
      if (this.hasLicense('Housekeeping')) {
        if (!isEmpty(this.housekeeping) && !isEmpty(this.housekeeping[roomNumber])) {
          return this.housekeeping[roomNumber].status || 'Clean';
        }
      }

      return '';
    },
    roomCleaningStatusIcon(roomNumber, style = 'fa-light') {
      if (this.hasLicense('Housekeeping')) {
        if (!isEmpty(this.housekeeping) && !isEmpty(this.housekeeping[roomNumber])) {
          switch (this.housekeeping[roomNumber].status) {
            case 'Dirty':
              return `${style} fa-broom-wide`;
            case 'Cleaning':
              return `${style} fa-broom-wide fa-beat`;
            case 'DoNotDisturb':
              return `${style} fa-bell-slash`;
            case 'Inspected':
              return `${style} fa-check-double`;
            case 'Clean':
              return `${style} fa-check`;
            case 'OutOfService':
            default:
              return '';
          }
        }
      }

      return '';
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';
  @import '~styles/components/lib/RoomPlan';
</style>



// WEBPACK FOOTER //
// src/components/lib/roomplan/Roomplan.vue